import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const EventCancelledPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [eventName, setEventName] = useState(location?.state?.eventName || 'このイベント');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const canceledStatuses = new Set([
    'cancellation_pending_payment',
    'canceled',
    'refunding',
    'cancellation_completed',
    'cancellation_failed',
  ]);

  useEffect(() => {
    let active = true;

    const verify = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/events/${id}`);
        const event = res?.data?.event;
        const status = String(event?.cancellation_status || 'none');
        const eventPathId = event?.slug || id;

        if (!canceledStatuses.has(status)) {
          navigate(`/events/${eventPathId}`, { replace: true });
          return;
        }

        if (active) {
          setEventName(event?.name || 'このイベント');
        }
      } catch (e) {
        if (active) {
          setError('イベント情報の取得に失敗しました。');
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    if (id) {
      verify();
    } else {
      setLoading(false);
      setError('イベント情報が見つかりません。');
    }

    return () => {
      active = false;
    };
  }, [id, navigate]);

  if (loading) {
    return <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1rem' }}>読み込み中...</div>;
  }

  if (error) {
    return <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1rem' }}>{error}</div>;
  }

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1 style={{ marginBottom: '0.75rem' }}>イベント中止のお知らせ</h1>
      <p style={{ marginBottom: '0.75rem' }}>{eventName}は中止されました。</p>
      <p style={{ marginBottom: '1.5rem', color: '#555' }}>
        ご迷惑をおかけし申し訳ございません。返金や手続き状況は、主催者からのお知らせをご確認ください。
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <Link to="/events">イベント一覧へ</Link>
        <Link to="/">トップへ戻る</Link>
      </div>
    </div>
  );
};

export default EventCancelledPage;
